import './main.scss';
import { loadComponents } from '@opten/helper-components';
import { FormField } from '@opten/forms/form-field';

import { MapExtendedComponent } from './components/map-extended/map-extended-component';
import { TabsComponent } from './components/tabs/tabs-component';
import { Header } from './components/header/header';
import { MixitupComponent } from './components/mixitup';
import { IFramePlayerComponent } from './components/player/player';
import { ModalComponent } from './components/modal/modal';
import { GallerySliderComponent } from './components/gallery-slider/gallery-slider';
import { Navbar, NavbarToggler, NavbarMegaDropdown } from './components/navbar';
import { AnchorComponent } from './components/anchor';
import { CollapseComponent } from './components/collapse-component';
import { RecaptchaValidatorComponent } from './components/recaptcha/recaptcha-validator-component';
// import { CookieConsentComponent } from './components/cookie-banner/cookie-consent-component';
import { NavbarMegaDropdownFavoriteAdded } from './components/navbar/navbar-mega-dropdown-favorite-added';
import { QuotesSliderComponent } from './components/quotes/quotes-slider';
import { PreviousAfterSliderComponent } from './components/previous-after/previous-after-slider';
import { CookieConsentComponent } from './components/cookie-bot/cookiebot.component';

loadComponents(
	CollapseComponent,
	Header,
	Navbar,
	NavbarMegaDropdown,
	NavbarMegaDropdownFavoriteAdded,
	NavbarToggler,
	MapExtendedComponent,
	FormField,
	TabsComponent,
	AnchorComponent,
	MixitupComponent,
	IFramePlayerComponent,
	ModalComponent,
	GallerySliderComponent,
	RecaptchaValidatorComponent,
	QuotesSliderComponent,
	PreviousAfterSliderComponent,
	CookieConsentComponent
);
